<template>
	<div class="lg:hidden" @click.stop>
		<transition name="fade">
			<div
				v-if="$store.state.sidebarOpen"
				class="fixed inset-0 z-40 bg-black/50 lg:hidden"
				@click="$store.commit('toggleSidebar')"
			/>
		</transition>

		<aside
			class="fixed inset-y-0 left-0 z-40 flex flex-col w-56 overflow-hidden text-black transition-all duration-200 ease-out bg-neutral-100 lg:translate-x-0 lg:shadow-none"
			:class="
				$store.state.sidebarOpen
					? 'translate-x-0 shadow-xl'
					: '-translate-x-full shadow-none'
			"
		>
			<div class="flex flex-col justify-between h-full">
				<div class="flex flex-col">
					<div
						class="flex items-center h-16 px-4 font-bold text-white shadow-lg bg-neutral-900"
					>
						<div class="flex justify-center w-6 mr-5 shrink-0">
							<NuxtLink to="/dashboard">
								<Logo class="block h-auto w-7" />
							</NuxtLink>
						</div>
						<div class="flex-1 min-w-0">
							<div class="truncate">
								{{ $org ? $org.name : greeting }}
							</div>
						</div>
					</div>

					<SidebarGroup>
						<SidebarItem
							v-for="link in mobilePrimaryLinks"
							:key="link.key"
							:label="$t(link.mobileLabelKey || link.labelKey)"
							:link="link.to"
						/>
					</SidebarGroup>
				</div>

				<div>
					<a
						v-if="$org"
						href="mailto:support@apropos.jobs"
						:title="$t('link.get-support-title')"
						class="flex w-full items-center justify-center gap-1 whitespace-nowrap px-4 py-4 text-center text-sm text-[#767676] transition-colors hover:text-[#303030]"
					>
						<IconEnvelope size="16" />
						{{ $t('link.contact-support') }}
					</a>
				</div>
			</div>
		</aside>
	</div>
</template>

<script>
import SidebarGroup from '~/components/ui/layout/Sidebar/SidebarGroup'
import SidebarItem from '~/components/ui/layout/Sidebar/SidebarItem'
import { IconEnvelope } from '~/components/Icons'
import { Logo } from '~/components/Logo'
import { buildAccountHeaderNavigation } from '../navigation'

export default {
	components: {
		Logo,
		SidebarGroup,
		SidebarItem,
		IconEnvelope
	},
	data() {
		return {
			greeting: this.$user?.firstname
				? this.$t('user.greeting', { name: this.$user.firstname })
				: this.$t('app.welcome')
		}
	},
	computed: {
		navigation() {
			return buildAccountHeaderNavigation(
				this.$user,
				this.$org,
				this.$applicantProfile
			)
		},
		mobilePrimaryLinks() {
			return this.navigation.primary
				.filter(link => link.showOnMobile)
				.sort((left, right) => (left.order || 99) - (right.order || 99))
		}
	}
}
</script>
